import { CompanyDto } from "../companies/company.dto";
import { OperativeUnitDto } from "../operative-units/operative-unit.dto";
import { Transform, Type } from "class-transformer";
import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { toEuros, toKilometers } from "@/utils/numberUtils";
import { parseApiDate } from "@/utils/dates/dateFormats";
import { AcquisitionTypeEnum, UsageTypeEnum, VehicleFuelTypeEnum, VehicleTypeEnum } from "@altertec_gparn/lib";
import { MileageDto } from "@/core/features/mileages/mileage.dto";
import { ColorType } from "@/types/ColorType";
import { getToday, setTimeToZero, toLocaleTimezone } from "@/utils/dates/dateUtils";
import { VehicleTypeHasChecklistDto } from "@/core/features/vehicle-types-have-checklists/vehicle-type-has-checklist.dto";
import { UserDto } from "@/core/features/users/user.dto";

export class VehicleDto extends BaseEntityDto {
  code: string;

  licensePlate: string;

  brand: string;

  model: string;

  @Transform(({ value }) => toEuros(value))
  dailyCost: number;

  archived: boolean;

  companyId: string;

  @Type(() => CompanyDto)
  company?: CompanyDto;

  operativeUnitId: string;

  @Transform(({ value }) => parseApiDate(value))
  registrationDate?: Date;

  @Transform(({ value }) => parseApiDate(value))
  deregistrationDate?: Date;

  @Type(() => OperativeUnitDto)
  operativeUnit?: OperativeUnitDto;

  vehicleType?: VehicleTypeEnum;
  usageType?: UsageTypeEnum;
  acquisitionType?: AcquisitionTypeEnum;

  solredCardNumber?: string;
  solredCardNumberMasked?: string;
  solredCardPin?: string;

  vehicleFuelType?: VehicleFuelTypeEnum;

  @Type(() => Number)
  seatsCount?: number;

  responsibleId?: string | null;

  @Type(() => UserDto)
  responsible?: UserDto;

  photoUrl?: string;

  color: ColorType;

  @Transform(({ value }) => toKilometers(value))
  latestMileage: number;

  @Type(() => MileageDto)
  mileages: MileageDto[];

  @Type(() => VehicleTypeHasChecklistDto)
  checklistTemplate?: VehicleTypeHasChecklistDto;

  @Transform(({ value }) => toLocaleTimezone(parseApiDate(value)))
  nextChecklistDeadline: Date;

  @Type(() => UserDto)
  updatedBy?: UserDto;

  toString(): string {
    return `${this.code} (${this.licensePlate})`;
  }

  isChecklistExpired(): boolean {
    const checklist = this.checklistTemplate?.checklist;
    if (!checklist?.isActive) return false;
    // A periodic checklist without deadline was never filled, so it is pending since the vehicle was registered.
    if (!this.nextChecklistDeadline) return checklist.hasPeriodicReview();
    return setTimeToZero(this.nextChecklistDeadline) <= getToday();
  }
}
